import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Dropdown,
  Button,
  Container,
  Image,
  Offcanvas
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faBell,
  faCog,
  faQuestionCircle,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

import "../styles/Main.css";
import { logoutToken } from "../helpers/utility";
import icon1 from "../assets/images/user.webp";
import NewLogo from "../assets/images/New Logo.svg";
import { FaChevronRight } from "react-icons/fa6";
import { PiSignOutBold } from "react-icons/pi";
import { FaBookmark } from "react-icons/fa6";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import { getJobSeeker } from "../helpers/backendHelper";
import { IMAGE_HOST_URL } from "../helpers/urlHelper";
import { GoBookmark } from "react-icons/go";
import { TfiEmail } from "react-icons/tfi";
import { IoNotificationsOutline } from "react-icons/io5";
import { FaUser } from "react-icons/fa";

 
const NavbarComponent = (props) => {

  const { user } = useSelector((state) => ({
    user: state.Login.user,
  }));

  const [decodeuser, setDecodeuser] = useState();
  const isLoggedIn = localStorage.getItem("authUser");
  const [userData, setUserData] = useState({
    jobSeekerProfileImage: icon1
  });

  useEffect(()=>{
    if (isLoggedIn) {
      try {
        const decodedToken = jwt_decode(isLoggedIn);
        console.log("decodedToken",decodedToken);
        setDecodeuser(decodedToken);
        if(decodedToken.userType === "Jobseeker"){
          fetchData();
        }
      } catch (error) {
        console.error("Invalid token:", error);
      }
    } else {
      console.warn("No token found in localStorage");
    }
  },[isLoggedIn]);

  const handleLogout = async (e) => {
    e.preventDefault();
    const confirm = await Swal.fire({
        icon: "question",
        text: "Are you sure you want to logout?",        
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonColor: '#3085d6',
        confirmButtonText: "Yes",
    });

    if(confirm.isConfirmed){
      await logoutToken();
    }
  };

  const navButtons=[
    {
      name : "Home",
      route : "/home"
    },
    {
      name : "About",
      route : "/about"
    },
    {
      name : "Jobs",
      route : "/jobs"
    },
    {
      name : "Courses",
      route : ""
    },
    {
      name : "Wildcard",
      route : ""
    }
  ]

  const fetchData = async() => {
    const response = await getJobSeeker();
    console.log("response...",response.jobseeker);
    setUserData(response.jobseeker)
  }

  return (
    <Navbar expand="lg" className="navbar navbar-expand-lg navbar-light navbar-bg-color">
      <Container fluid className="navbar-container nav-container">
        <Navbar.Brand as={Link} to="/home" className="navbar-brand d-flex text-white pt-2">
          <Image src={NewLogo} fluid className="nav-logo" />
        </Navbar.Brand>

        <Nav className="ml-auto d-flex flex-row align-items-center d-block d-lg-none">
            { isLoggedIn && decodeuser?.userType === "Jobseeker" ?
              <Nav.Link as={Link} to="/savedjobs" className="nav-link" title="Saved Jobs">
                <GoBookmark className="me-2 text-dark fs-5"/>
              </Nav.Link> : null
            }

            {/* <Nav.Link as={Link} to="/savedjobs" className="nav-link" title="Saved Jobs">
              <GoBookmark className="me-2 text-dark fs-5"/>
            </Nav.Link> */}
            
            <Nav.Link as={Link} to="/message" className="nav-link" title="Messages">
              {/* <FontAwesomeIcon icon={faEnvelope} size={50} className="mx-2 text-dark" /> */}
              <TfiEmail className="mx-2 text-dark fs-5" />
            </Nav.Link>
            <Nav.Link as={Link} to="/Notification" className="nav-link" title="Notifications">
              {/* <FontAwesomeIcon icon={faBell} size={50} className="mx-2 text-dark" /> */}
              <IoNotificationsOutline className="mx-2 text-dark fs-5" />
            </Nav.Link>

            <Navbar.Toggle aria-controls="offcanvasNavbar" className="bg-white" />
        </Nav>
        
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="navbar-offcanvas offcanvas-height"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">
              Menu
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="mx-auto">
              { navButtons.map((val,index)=>
                <Nav.Link key={index} as={Link} to={val.route} className="nav-link navbar-text-bold d-none d-lg-block my-1">{val.name}</Nav.Link>
              )}

              <Nav.Link as={Link} to="/home" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Home</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">About</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/jobs" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Jobs</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Courses</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Wildcard</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Company reviews</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Salary guide</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Employers</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/jobSeeker/profile" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Profile</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/myreviews" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">My Reviews</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/settings" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Settings</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="/helpcenter" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Help centre</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              <Nav.Link as={Link} to="" className="nav-link navbar-text-bold d-flex d-lg-none justify-content-between menu-content">
                <p className="mt-2">Terms</p>
                <FaChevronRight className="mt-2"/>
              </Nav.Link>
              

            </Nav>
            <div className="d-flex align-items-center">
              <Nav className="ml-auto d-flex align-items-center">
                { isLoggedIn && decodeuser?.userType === "Jobseeker" ? 
                  <Nav.Link as={Link} to="/savedjobs" className="nav-link d-none d-lg-block" title="Saved Jobs">
                    <GoBookmark className="fs-5"/>
                  </Nav.Link> : null
                }

                {/* <Nav.Link as={Link} to="/savedjobs" className="nav-link d-none d-lg-block" title="Saved Jobs">
                  <GoBookmark className="fs-5"/>
                </Nav.Link> */}
                
                <Nav.Link as={Link} to="/message" className="d-none d-lg-block" title="Messages">
                  {/* <FontAwesomeIcon icon={faEnvelope} size={55} className="ms-1" /> */}
                  <TfiEmail className="fs-5" />
                </Nav.Link>
                <Nav.Link as={Link} to="/Notification" className="nav-link d-none d-lg-block" title="Notifications">
                  {/* <FontAwesomeIcon icon={faBell} size={50} className="ms-1" /> */}
                  <IoNotificationsOutline className="fs-5" />
                </Nav.Link>

                { isLoggedIn && decodeuser?.userType === "Jobseeker" ? (
                  <>
                    <Dropdown drop="down" className="d-none d-lg-block" title="Profile">
                      <Dropdown.Toggle as={Button} variant="link" className="text-black px-2" id="dropdown-basic">
                        <Image 
                          src={userData?.jobSeekerProfileImage === "null" ? icon1 : `${IMAGE_HOST_URL}${userData?.jobSeekerProfileImage}`} 
                          height="25" 
                          className="rounded-pill" 
                        />
                      </Dropdown.Toggle>  

                      <Dropdown.Menu align="end" className="flex-row">
                        <Dropdown.Item as={Link} to="/jobSeeker/profile" className="nav-background d-flex justify-content-start align-items-center" title="Profile">
                          <FaUser />
                          <span className="text-decoration-none text-dark p-2 nav-link navbar-text">
                            Profile
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/myjobs" className="nav-background" title="My Jobs">
                          <FontAwesomeIcon icon={faCog} className="mr-2 white-icon text-dark" />
                          <span className="text-decoration-none text-dark p-2">
                            My Jobs
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/myreviews" className="nav-background" title="My Reviews">
                          <FontAwesomeIcon icon={faStar} className="mr-2" />
                          <span className="text-decoration-none text-dark p-2">
                            My Reviews
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/settings" className="nav-background" title="Settings">
                          <FontAwesomeIcon icon={faCog} className="mr-2" />
                          <span className="text-decoration-none text-dark p-2">
                            Settings
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/helpcenter" className="nav-background" title="Help Center">
                          <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
                          <span className="text-decoration-none text-dark p-2">
                            Help Center
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={handleLogout} className="nav-background" title="Logout">
                          <div className="d-flex justify-contant-start align-items-center">
                            <PiSignOutBold className="text-decoration-none text-dark"/>
                            <span className="ms-2">Logout</span>
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div as={Link} to="" className="navbar-text d-flex d-lg-none mt-1">
                      <div className="cursor-pointer d-flex justify-content-start">
                        <PiSignOutBold className="mt-1 fs-5 text-decoration-none text-dark"/>
                        <p className="ms-1 navbar-text-bold" onClick={handleLogout}>SignOut</p>
                      </div>
                    </div>
                  </>
                  
                ) : null}
                { isLoggedIn && decodeuser?.userType === "Jobseeker" ? null : (
                  <Nav.Link as={Link} to="/auth/signup" className="nav-link navbar-text-bold mt-1 mt-lg-0">
                    SignUp / SignIn
                  </Nav.Link>
                )}
                <div className="space-div d-flex d-lg-none">

                </div>
                
              </Nav>
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
